@if (actionParams && actionResults && actionDefaultResults) {
  <div class="form-container">
    <clickatell-expansion-panel>
      <ng-container header>
        <mat-panel-title>
          Parameters
        </mat-panel-title>
      </ng-container>
      <ng-container body>
        <ng-container [formGroup]="actionParams">
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Name </label>
            </div>
            <ng-container
              *ngTemplateOutlet="validators; context: { myControlName: 'name', myForm: actionParams}">
            </ng-container>
            <input class="control-input" activeForm [activeForm]="actionParams" id="name" [formControlName]="'name'" placeholder="Enter a name"/>
          </div>
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Description </label>
            </div>
            <ng-container
              *ngTemplateOutlet="validators; context: { myControlName: 'description', myForm: actionParams}">
            </ng-container>
            <input class="control-input" activeForm [activeForm]="actionParams" id="description" [formControlName]="'description'" placeholder="Enter a description"/>
          </div>
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Reference </label>
            </div>
            <ng-container
              *ngTemplateOutlet="validators; context: { myControlName: 'reference', myForm: actionParams}">
            </ng-container>
            <input class="control-input" activeForm [activeForm]="actionParams" id="reference" [formControlName]="'reference'" placeholder="Enter variable containing UUID"/>
          </div>
        </ng-container>
      </ng-container>
    </clickatell-expansion-panel>
    <clickatell-expansion-panel>
      <ng-container header>
        <mat-panel-title>
          Logic
        </mat-panel-title>
      </ng-container>
      <ng-container body>
        @for (actionResultsFrom of actionResults.controls; track actionResultsFrom; let i = $index) {
          <div class="control-result" [formGroup]="actionResultsFrom">
            <div class="control-result-header">
              @if (actionResultsFrom.value['key']) {
                {{actionResultsFrom.value['key']}}
              } @else {
                <span class="control-result-defaultTitle">
                  [Result Name]
                </span>
              }
              <button class="control-result-delete" [disabled]="!canEdit" (click)="deleteResult(i)">
                <img class="control-result-delete-btn" src="./assets/svg/redesign/trash.svg">
              </button>
            </div>
            <div class="control-result-container">
              <div class="control-div">
                <div class="control-label-container">
                  <label class="control-label"> Result </label>
                </div>
                <ng-container
                  *ngTemplateOutlet="validators; context: { myControlName: 'key', myForm: actionResultsFrom}">
                </ng-container>
                <input class="control-input" activeForm [activeForm]="actionResultsFrom" [id]="'Result-' + i" [formControlName]="'key'" placeholder="Enter a name"/>
              </div>
              <div class="control-div">
                <label class="control-label">
                  <span class="pont-to">Point To</span>
                  <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
                </label>
                @if (nodeFlowDetails) {
                  <next-selector [canEditFlows]="canEdit.canEditFlows" [selectorType]="'both'"
                    [flowSteps]="nodeFlowDetails.currentFlowSteps" [flows]="nodeFlowDetails.flows"
                    [name]="'next'"
                    [form]="actionResultsFrom"
                    [stepId]="nodeFlowDetails.stepId">
                  ></next-selector>
                }
              </div>
            </div>
          </div>
        }
        <div class="control-add-button">
          <button (click)="addResult()" [disabled]="!canEdit">
            Add New Result
          </button>
        </div>
        @for (defaultResultForm of actionDefaultResults.controls; track defaultResultForm; let i = $index) {
          <div class="control-result" [formGroup]="defaultResultForm">
            <div class="default-result-header">
              <span class="imageStyle">
                <img src="assets/nodeSvg/{{defaultResultForm.controls.key.value}}.svg" width="17px">
              </span>
              {{defaultResultForm.controls.key.value}}
            </div>
            <div class="control-result-container">
              <div class="control-div">
                <label class="control-label">
                  <span class="pont-to">Point To</span>
                  <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
                </label>
                @if (nodeFlowDetails) {
                  <next-selector [canEditFlows]="canEdit.canEditFlows" [selectorType]="'both'"
                    [flowSteps]="nodeFlowDetails.currentFlowSteps" [flows]="nodeFlowDetails.flows"
                    [name]="'next'"
                    [form]="defaultResultForm"
                    [stepId]="nodeFlowDetails.stepId">
                  ></next-selector>
                }
              </div>
            </div>
          </div>
        }
      </ng-container>
    </clickatell-expansion-panel>
  </div>
}

<ng-template #validators let-myControlName="myControlName" let-myForm=myForm>
  @if (myForm.controls[myControlName]; as control) {
    @if (control.invalid && (control.dirty || control.touched)) {
      <div class="validationField">
        @for (error of control.errors | keyvalue; track error) {
          <div>
            <span class="fa fa-exclamation-circle"></span>
            <span [id]="'validationField-' + myControlName">
              {{error.value}}
            </span>
          </div>
        }
      </div>
    }
  }
</ng-template>
